/**
 * "Is the profile complete enough to skip the onboarding-banner step"
 * check.
 *
 * Used by the [[RequireAuth]] guard to redirect users with an
 * incomplete profile to /profile, and by [[Profile]] itself to render
 * the welcome banner.
 *
 * Gate: full_name only, for every role. It's the operator-recognised
 * identifier on audit rows, the Sessions list's actor column, and the
 * participants picker's primary line on the kiosk.
 *
 * Title + years_of_experience are deliberately NOT gated here
 * (LOGIN-LANDING). They're cohort context the trait-score reports want,
 * but operators — not the participant — routinely create participant
 * accounts without them, so gating on them here perpetually bounced
 * returning participants back to /profile instead of their dashboard.
 * Onboarding is now nudged once, at first login, by routing first-timers
 * (users with no server-side last_login_at) to /profile; every login
 * after that lands on /dashboard. The participant-only Profile Save
 * button still asks for title + years.
 */
import type { CurrentUser } from '../api/users';

export function isProfileComplete(user: CurrentUser | null): boolean {
  if (user === null) return true; // unauthenticated — nothing to gate.

  const fullName = user.full_name?.trim() ?? '';
  if (fullName.length === 0) return false;

  return true;
}
